import { memo, VFC, useEffect, useState } from 'react';
import {
  Center,Heading,Box,Flex,Spacer,Divider,Text,Spinner,
  Tabs,TabList,TabPanels,Tab,TabPanel,
} from '@chakra-ui/react';
// import { useLoginUser } from '../../../hooks/providers/useLoginUserProvider';
import { IssueGroupDetail } from '../../molecules/IssueGroupDetail';
import { IssueGroupTable } from '../../molecules/IssueGroupTable';
import { CustomerTable } from '../../molecules/CustomerTable';
import { CaseTableGroup } from '../../molecules/CaseTable';
import { getIssueGroupResult } from '../../../types/issue';
import { useLoginUser } from "../../../hooks/providers/useLoginUserProvider";
import { CopyButton } from "../../atoms/button/CopyButton";

type Props = {
  getIssueGroupResult: getIssueGroupResult|null;
  executing: boolean;
  setIssueArn: (issueArn:string)=>void;
  setExecFlag: (flag:boolean)=>void;
};

export const IssueGroupDetailBase: VFC<Props> = memo((props) => {
  const { getIssueGroupResult, executing, setIssueArn, setExecFlag } = props;
  const { loginUser } = useLoginUser();
  const [ dataTime, setDataTime ] = useState("");
  const host = window.location.host;
  
  useEffect(() => {
    if( getIssueGroupResult ){
      let set_data_time = getIssueGroupResult.get_data_time ?? ""
      if ( set_data_time ){
        set_data_time = '(' + set_data_time + ' 現在)'
      }
      setDataTime(set_data_time);
    }
  }, [getIssueGroupResult]);

  return (
    <Center> 
      <Box
        w="100%"
        bg="white"
        borderRadius="10px"
        shadow="md"
        margin="0px"
      >
        <Flex m="10px" marginRight="15px">
          <Heading size="md" margin="5px">
            <Flex>■障害グループ情報 <Text color="green">{dataTime} </Text></Flex>
          </Heading> 
          <Spacer />
          {getIssueGroupResult &&
            <CopyButton
              id="copy"
              isLoading={executing}
              value={`https://${host}/login.html?groupName=` + encodeURIComponent(getIssueGroupResult.group_name_org)}>
              URLをコピー
            </CopyButton>
          }
        </Flex>
        
        {(executing || !getIssueGroupResult) ? (
          <Center h="80vh">
            <Spinner color="teal.500" />
          </Center>
        ) : (
          <>
          <Divider orientation="horizontal" mt="10px" />
          <IssueGroupDetail getIssueGroupResult={getIssueGroupResult} loading={executing} setExecFlag={setExecFlag} />
          
          {getIssueGroupResult.aws_fail_list.length > 0 && (
            <Box mt="20px" margin="10px">
              <Tabs align="center" variant="enclosed-colored">
                <TabList id="mypagetabs">
                  <Tab>障害一覧</Tab>
                  <Tab>影響アカウント一覧</Tab>
                  {loginUser.necFlag && (
                    <Tab>問い合わせ状況</Tab>
                  )}
                </TabList>
                  
                <TabPanels>
                
                  <TabPanel>
                    <IssueGroupTable getIssueGroupResult={getIssueGroupResult} setIssueArn={setIssueArn} />
                  </TabPanel>
                  
                  <TabPanel>
                    <CustomerTable
                      executing={executing}
                      custList1={getIssueGroupResult.customer_list1}
                      custList2={getIssueGroupResult.customer_list2}
                      custList3={getIssueGroupResult.customer_list3}
                      mode='group' />
                  </TabPanel>
                  
                  {loginUser.necFlag && (
                    <TabPanel>
                      {getIssueGroupResult.case_list.length === 0 ? (
                        <>
                        <br />
                          <Text fontSize="lg">本障害に関係する問い合わせはありません。</Text>
                        <br />
                        </>
                      ) : (
                        <CaseTableGroup caseList={getIssueGroupResult.case_list} />
                      )}
                    </TabPanel>
                  )}
                  
                </TabPanels>
              </Tabs>
            </Box>
          )}
          </>
        )}
      </Box>
    </Center>
  );
});